import { Spin } from 'antd';
import { BoxplotChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Data {
  categories: string[];
  data: number[][];
}

function BoxplotWidget({ instance }: WidgetRenderProps) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'boxplot', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <BoxplotChart categories={data?.categories ?? []} data={data?.data ?? []} />;
}

export const boxplotWidgetDef: WidgetDefinition = {
  type: 'boxplot',
  name: 'Box Plot',
  description: 'Statistical distribution',
  icon: 'BuildOutlined',
  category: 'chart',
  defaultTitle: 'Box Plot',
  defaultConfig: {},
  minW: 4, minH: 4, defaultW: 6, defaultH: 6,
  component: BoxplotWidget,
  settingsSchema: { fields: [] },
};
